(function () {
    "use strict";

    angular.module('app').directive('invoiceDatepicker', InvoiceDatePicker);

    InvoiceDatePicker.$inject = [];
    function InvoiceDatePicker() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                languageCode: '@',
                onChangeDate: '=?',
                datepickerName: '@',
                placeHolder: '@',
                mask: '@'
            },
            controller: ['$scope', function ($scope) {
                $scope.mask = angular.isDefined($scope.mask) ? $scope.mask : "99/99/9999";
            }],
            template: '<div ng-attr-id="div_{{datePickerName}}">' +
                '<div ng-attr-id="div_{{datePickerName}}_dp" class="input-group date">' +
                '<input type="text" class="form-control" mask="{{mask}}" placeholder="{{placeHolder}}">' +
                '<span class="input-group-addon"><i class="glyphicon glyphicon-th"></i></span>' +
                '</div>' +
                '<input type="hidden" ng-attr-id="{{datePickerName}}" name="{{datePickerName}}">' +
                '</div>',

            link: function ($scope, element) {
                const dpInput = $($(element)[0].children[0]);
                const textInput = $("#" + $scope.datePickerName);

                dpInput.datepicker(
                    {
                        endDate: new Date(),
                        language: ($scope.languageCode) ? $scope.languageCode : 'en',
                        autoclose: true,
                        clearBtn: true,
                        maxViewMode: 1,
                        orientation: "bottom"
                    });

                function onDateChange() {
                    const selectedDate = dpInput.datepicker('getUTCDate');
                    let dateValue = null;
                    if (selectedDate) {
                        const month = selectedDate.getMonth() + 1;
                        const year = selectedDate.getFullYear();
                        dateValue = month + "/" + year;
                        textInput.val(dateValue);
                    }
                    $scope.onChangeDate(selectedDate);
                }

                dpInput.bind('changeDate', onDateChange);
                dpInput.bind('keyup', onDateChange);
            },
        };
    }
})();